module.exports = __webpack_public_path__ + "img/19.c992ed36.png";